<script>
import { h } from "vue";

export default {
  name: "ReasonItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    categoryIndex: {
      type: Number,
      default: 0,
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getSubcategoryBgClass(index) {
      const classes = [
        "bg-gray-100 rounded p-3 hover:bg-gray-200 transition-colors",
        "bg-gray-200 rounded p-3 hover:bg-gray-300 transition-colors",
        "bg-gray-100 rounded p-3 hover:bg-gray-200 transition-colors",
        "bg-gray-200 rounded p-3 hover:bg-gray-300 transition-colors",
      ];
      return classes[index % classes.length];
    },
    handleExport(reasonId) {
      this.$emit("export", reasonId);
    },
  },
  render() {
    // Only level 2 (reasons) can be exported - depth 1 means it's a reason (level 2)
    const isReasonLevel = this.depth === 1;
    const tooltip =
      this.$t("reports.call_reasons_report.export_tooltip") ||
      "Click to export";
    const hasChildren = this.item.children && this.item.children.length > 0 && this.depth < 2;

    return h("div", { class: this.getSubcategoryBgClass(this.categoryIndex) }, [
      h("div", { class: "text-center" }, [
        h("div", { class: "text-md font-bold text-gray-800" }, this.item.count),
        h(
          "div",
          {
            class: isReasonLevel
              ? "text-xs font-semibold text-gray-700 mt-1 cursor-pointer hover:text-blue-600 transition-colors"
              : "text-xs font-semibold text-gray-700 mt-1",
            title: isReasonLevel ? tooltip : undefined,
            onClick: isReasonLevel ? () => this.handleExport(this.item.id) : undefined,
          },
          this.item.name
        ),
      ]),
      hasChildren
        ? h(
            "div",
            { class: "mt-2 pt-2 border-t border-gray-300" },
            this.item.children.map((child, index) =>
              h(this.$options, {
                key: `depth-${this.depth}-cat-${this.categoryIndex}-id-${
                  child.id || index
                }`,
                item: child,
                categoryIndex: this.categoryIndex,
                depth: this.depth + 1,
                onExport: this.handleExport,
              })
            )
          )
        : null,
    ]);
  },
};
</script>

